/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipient_Team_LeadInputs */

const cs_recipient_team_lead = /** @type {(inputs: Recipient_Team_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedoucí týmu`)
};

const en_recipient_team_lead = /** @type {(inputs: Recipient_Team_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team lead`)
};

/**
* | output |
* | --- |
* | "Team lead" |
*
* @param {Recipient_Team_LeadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const recipient_team_lead = /** @type {((inputs?: Recipient_Team_LeadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipient_Team_LeadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recipient_team_lead(inputs)
	return cs_recipient_team_lead(inputs)
});